import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

class Smiley extends React.Component {
  render() {
    var smiley = <i></i>;
    var classes = "";
    var color = {};
    var datasmiley = "";
    if (this.props.smiley_score == 100) {
      classes = "far fa-laugh fa-2x fa-stack-1x";
      color = '#01ff02';
      datasmiley = "100";
    } else if (this.props.smiley_score == 75) {
      classes = "far fa-smile fa-2x fa-stack-1x";
      color = '#abef0e';
      datasmiley = "75";
    } else if (this.props.smiley_score == 50) {
      classes = "far fa-meh fa-2x fa-stack-1x";
      color = '#b5b5b5';
      datasmiley = "50";
    } else if (this.props.smiley_score == 25) {
      classes = "far fa-frown fa-2x fa-stack-1x";
      color = '#ffcf08';
      datasmiley = "25";
    } else if (this.props.smiley_score == 0) {
      classes = "far fa-angry fa-2x fa-stack-1x";
      color = '#fe0100';
      datasmiley = "0";
    }

    if (this.props.smiley_score >= 0 && this.props.smiley_score != null) {
      smiley = <span className="d-flex"><span className="fa-stack" style={{ fontSize: "0.75em" }}><i className="fas fa-circle  fa-stack-2x" style={{ color: color }}></i><i className={classes} style={{ color: "#000000" }} data-smiley={datasmiley}></i></span></span>
    }
    if ((this.props.smiley_score == -1 || this.props.smiley_score == null) && this.props.is_feedback_detail == true && !this.props.secondMode) {
      smiley = <span className="text-muted"> None</span>;
    }
    return (smiley);
  }
}

export default Smiley;